import { toolbarButtonStyles } from 'components/topics/composer/toolbars/toolbar_button'
import NimblePicker from 'emoji-mart/dist-es/components/picker/nimble-picker'
import { useFetchEmojiData } from 'hooks/use_fetch_emoji_data'
import React from 'react'

import { buttonStyles } from 'primitives/button'
import * as Popover from 'primitives/popover'
import { cn } from 'util/cn'

import { ComposerReactionIcon } from '../../images'

export type TrixEmojiProps = {
  editor: any
  activeType: 'message' | 'note'
}

export const TrixEmoji = ({ editor, activeType }: TrixEmojiProps) => {
  const { data } = useFetchEmojiData()

  return (
    <Popover.Root>
      <Popover.Trigger
        className={cn(
          'topic__toolbarbutton',
          buttonStyles({
            shape: 'square',
            variant: 'tertiary',
          }),
          toolbarButtonStyles({ activeType }),
        )}
        data-trix-key="shift+e"
        title="Add an Emoji"
      >
        <ComposerReactionIcon />
      </Popover.Trigger>
      <Popover.Content>
        {data && (
          <NimblePicker
            data={data as any}
            onSelect={(e: any) => {
              editor.insertString(e.native)
            }}
            title="Pick your emoji…"
            emoji="point_up"
            set="apple"
          />
        )}
      </Popover.Content>
    </Popover.Root>
  )
}
